import { ReactElement } from 'react';
import UserHoverCard from '@molecules/UserHoverCard/UserHoverCard';

/**
 * Кружок сотрудника с карточкой по наведению, когда известен его пользователь. `suppressed` — по нажатию открыто меню
 * громкости: карточка не мешает.
 */
export const withPersonCard = (userKey: string | undefined, name: string, node: ReactElement, suppressed = false) =>
    userKey ? (
        <UserHoverCard userKey={userKey} fallbackName={name} position="bottom" suppressed={suppressed}>
            {node}
        </UserHoverCard>
    ) : (
        node
    );
